import React, { useState, useRef, Component } from 'react';
import { motion } from 'framer-motion';
import { ShoppingBag, ChevronLeft, ChevronRight } from 'lucide-react';
import { useLanguage } from './LanguageContext';
const catalogProducts = [{
  name: 'Barbaros Royal Lion Eau de Cologne',
  size: '500ml / 16.9 FL OZ',
  price: '$17.99',
  image: 'https://cdn.magicpatterns.com/uploads/7NNLyd6Ygt5bmAJn3kNLYC/WhatsApp_Image_2026-05-04_at_10.00.35_AM_(1).jpg',
  category: 'Fragancia'
}, {
  name: 'Rolda Curl Cream',
  size: 'Crema Para Rizos',
  price: '$12.99',
  image: 'https://cdn.magicpatterns.com/uploads/9gxFPXvEhKdnKX5E7azDmL/WhatsApp_Image_2026-05-04_at_10.00.35_AM_(2).jpg',
  category: 'Hair Care'
}, {
  name: 'Rolda Hair Gel Black',
  size: 'Extra Strong Hold',
  price: '$12.99',
  image: 'https://cdn.magicpatterns.com/uploads/nV2YNNyESS6sUoamdkbyHP/WhatsApp_Image_2026-05-04_at_10.00.35_AM_(3).jpg',
  category: 'Hair Care'
}, {
  name: 'Isoplus Oil Sheen Hair Spray',
  size: '11 Oz / 312g',
  price: '$8.99',
  image: 'https://cdn.magicpatterns.com/uploads/mWYdL2kcsnxhvCEcpDTz99/WhatsApp_Image_2026-05-04_at_10.00.35_AM_(4).jpg',
  category: 'Hair Care'
}, {
  name: 'Clippercide Spray',
  size: '15 Oz — 5-in-1 Formula',
  price: '$12.99',
  image: 'https://cdn.magicpatterns.com/uploads/gC21mLoKZgyojYRHrxGErG/WhatsApp_Image_2026-05-04_at_10.00.35_AM.jpg',
  category: 'Desinfectante'
}, {
  name: 'Immortal NYC Dragon Leave In & Detangler Spray',
  size: '500ml / 16.9 FL OZ',
  price: '$14.99',
  image: 'https://cdn.magicpatterns.com/uploads/jam8iEP75ATrBFKgjCKMm6/WhatsApp_Image_2026-05-04_at_10.00.37_AM_(1).jpg',
  category: 'Hair Care'
}, {
  name: 'Immortal NYC Original Reserve Samurai Spirit',
  size: 'Baume Après-Rasage — 500ml',
  price: '$17.99',
  image: 'https://cdn.magicpatterns.com/uploads/bbavoVe71az2LaMbN3WvGr/WhatsApp_Image_2026-05-04_at_10.00.37_AM_(2).jpg',
  category: 'After Shave'
}, {
  name: 'Cool Style Eau de Cologne — One Million Dollars',
  size: 'Fragancia Premium',
  price: '$12.99',
  image: 'https://cdn.magicpatterns.com/uploads/uypMuSyx5qmfy93rVUw2Mm/WhatsApp_Image_2026-05-04_at_10.00.37_AM.jpg',
  category: 'Fragancia'
}, {
  name: 'L3VEL3 Shaving Gel Aqua',
  size: '500ml / 16.9 FL OZ',
  price: '$9.99',
  image: 'https://cdn.magicpatterns.com/uploads/pNgRAYbsLR8TknepSAEu2D/WhatsApp_Image_2026-05-04_at_10.00.38_AM_(1).jpg',
  category: 'Shaving'
}, {
  name: 'Nishman Shaving Gel 02 Energizing',
  size: '1000ml — Moisturizing Effect',
  price: '$6.99',
  image: 'https://cdn.magicpatterns.com/uploads/cDa2cp56UXwumdfh5HtBqs/WhatsApp_Image_2026-05-04_at_10.00.38_AM_(7).jpg',
  category: 'Shaving'
}, {
  name: 'Nishman Hair Gel 5+ Gum Effect',
  size: '750ml — Ultra Hold',
  price: '$9.99',
  image: 'https://cdn.magicpatterns.com/uploads/3G3BbFv4Vxj7GUfyukNSAX/WhatsApp_Image_2026-05-04_at_10.00.38_AM_(8).jpg',
  category: 'Hair Care'
}, {
  name: 'Gummy Professional Hair Gel Maximum Hold',
  size: '1000ml / 33.81 FL OZ',
  price: '$12.99',
  image: 'https://cdn.magicpatterns.com/uploads/6JJgHHEd4bWQD2v6nZaoJA/WhatsApp_Image_2026-05-04_at_10.00.38_AM_(9).jpg',
  category: 'Hair Care'
}, {
  name: 'Eco Style Krystal Styling Gel',
  size: 'Max Hold — For All Hair Types',
  price: '$8.99',
  image: 'https://cdn.magicpatterns.com/uploads/8kkPnbNd6Z8rDW4A7M6nvs/WhatsApp_Image_2026-05-04_at_10.00.38_AM_(10).jpg',
  category: 'Hair Care'
}, {
  name: 'Pro Shave Brushless Shaving Cream',
  size: '24 Oz — Lanolin & Vitamin E',
  price: '$12.99',
  image: 'https://cdn.magicpatterns.com/uploads/hofbd2qBWSdccDG7bY3Agn/WhatsApp_Image_2026-05-04_at_10.00.38_AM_(11).jpg',
  category: 'Shaving'
}];
export function Catalog() {
  const {
    t
  } = useLanguage();
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const checkScroll = () => {
    if (!scrollRef.current) return;
    const {
      scrollLeft,
      scrollWidth,
      clientWidth
    } = scrollRef.current;
    setCanScrollLeft(scrollLeft > 10);
    setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 10);
  };
  const scroll = (direction: 'left' | 'right') => {
    if (!scrollRef.current) return;
    const cardWidth = 220;
    const scrollAmount = direction === 'left' ? -cardWidth * 2 : cardWidth * 2;
    scrollRef.current.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
    setTimeout(checkScroll, 350);
  };
  return <section id="catalogo" className="py-20 bg-barber-black" data-id="element-17">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-19">
          <div className="inline-flex items-center gap-2 bg-barber-gold/10 border border-barber-gold/30 text-barber-gold px-5 py-2 rounded-full text-sm font-bold uppercase tracking-widest mb-6" data-id="element-20">
            <ShoppingBag size={16} data-id="element-21" />
            {t.catalog.badge}
          </div>
          <h2 className="text-4xl md:text-6xl font-oswald font-bold mb-4" data-id="element-22">
            {t.catalog.title1}{' '}
            <span className="text-barber-gold" data-id="element-23">{t.catalog.title2}</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-xl mx-auto" data-id="element-24">
            {t.catalog.subtitle}
          </p>
        </motion.div>

        {/* Carousel Navigation */}
        <div className="flex items-center justify-end gap-3 mb-6 px-2" data-id="element-25">
          <button onClick={() => scroll('left')} disabled={!canScrollLeft} className={`p-2.5 rounded-full border transition-colors ${canScrollLeft ? 'border-barber-gold text-barber-gold hover:bg-barber-gold hover:text-barber-black' : 'border-white/10 text-white/20 cursor-not-allowed'}`} aria-label="Anterior" data-id="element-26">
            <ChevronLeft size={20} data-id="element-27" />
          </button>
          <button onClick={() => scroll('right')} disabled={!canScrollRight} className={`p-2.5 rounded-full border transition-colors ${canScrollRight ? 'border-barber-gold text-barber-gold hover:bg-barber-gold hover:text-barber-black' : 'border-white/10 text-white/20 cursor-not-allowed'}`} aria-label="Siguiente" data-id="element-28">
            <ChevronRight size={20} data-id="element-29" />
          </button>
        </div>
      </div>

      {/* Carousel Track */}
      <div className="relative" data-id="element-30">
        {/* Left fade */}
        {canScrollLeft && <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-barber-black to-transparent z-10 pointer-events-none" data-id="element-31" />}
        {/* Right fade */}
        {canScrollRight && <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-barber-black to-transparent z-10 pointer-events-none" data-id="element-32" />}

        <div ref={scrollRef} onScroll={checkScroll} className="flex gap-5 overflow-x-auto px-6 md:px-12 pb-4 snap-x snap-mandatory cursor-grab active:cursor-grabbing touch-pan-x" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        WebkitOverflowScrolling: 'touch'
      }} onMouseDown={e => {
        const el = scrollRef.current;
        if (!el) return;
        el.dataset.dragging = 'true';
        el.dataset.startX = String(e.pageX - el.offsetLeft);
        el.dataset.scrollLeft = String(el.scrollLeft);
      }} onMouseMove={e => {
        const el = scrollRef.current;
        if (!el || el.dataset.dragging !== 'true') return;
        e.preventDefault();
        const x = e.pageX - el.offsetLeft;
        const walk = (x - Number(el.dataset.startX)) * 1.5;
        el.scrollLeft = Number(el.dataset.scrollLeft) - walk;
      }} onMouseUp={() => {
        const el = scrollRef.current;
        if (el) el.dataset.dragging = 'false';
        checkScroll();
      }} onMouseLeave={() => {
        const el = scrollRef.current;
        if (el) el.dataset.dragging = 'false';
        checkScroll();
      }} data-id="element-33">
          {catalogProducts.map((product, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="group flex-shrink-0 w-[200px] snap-start" data-id="element-34">
              {/* Compact Card */}
              <div className="bg-barber-dark rounded-lg border border-white/5 overflow-hidden hover:border-barber-gold/40 transition-colors duration-300" data-id="element-35">
                {/* Small Image */}
                <div className="relative aspect-[3/4] bg-black overflow-hidden" data-id="element-36">
                  <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-37" />
                  <span className="absolute top-2 left-2 bg-barber-black/80 text-barber-gold text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-full border border-barber-gold/30" data-id="element-38">
                    {product.category}
                  </span>
                </div>

                {/* Product Info — Compact */}
                <div className="p-3" data-id="element-39">
                  <h3 className="font-oswald text-sm font-bold text-white mb-0.5 leading-tight line-clamp-2" data-id="element-40">
                    {product.name}
                  </h3>
                  <p className="text-gray-500 text-xs mb-2" data-id="element-41">{product.size}</p>
                  <div className="flex items-center justify-between" data-id="element-42">
                    <span className="text-barber-gold font-oswald text-xl font-bold" data-id="element-43">
                      {product.price}
                    </span>
                    <a href={`https://wa.me/17185824903?text=${encodeURIComponent(`Hola, me interesa ordenar: ${product.name} (${product.price})`)}`} target="_blank" rel="noopener noreferrer" className="bg-barber-gold hover:bg-barber-gold-hover text-barber-black font-oswald font-bold text-[10px] px-3 py-1.5 rounded transition-colors uppercase tracking-wide" data-id="element-44">
                      {t.catalog.orderBtn}
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>

      {/* Bottom CTA */}
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-45">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="text-center mt-12" data-id="element-46">
          <p className="text-gray-400 mb-6 text-lg" data-id="element-47">{t.catalog.bottomText}</p>
          <a href="#productos" className="inline-block border-2 border-barber-gold text-barber-gold hover:bg-barber-gold hover:text-barber-black font-oswald font-bold text-lg px-10 py-4 rounded transition-colors uppercase tracking-wide" data-id="element-48">
            {t.catalog.bottomBtn}
          </a>
        </motion.div>
      </div>
    </section>;
}